import { Spinner } from "@blueprintjs/core";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import http from "../../../utils/http";
import { API_BASE_CEAM, ROUTES } from "../../../utils/routes";
import SZCForm from "./SZCForm";

const SZCEdit = (props) => {
  const [szc, setSZC] = useState();

  const { id } = useParams();

  useEffect(() => {
    getSzc();
  }, []);

  const getSzc = async () => {
    const data = await http.get(`${API_BASE_CEAM}/api/szc/${id}/full`);
    setSZC(data);
  };

  const handleEditSubmit = async ({ szc, instituteIds }) => {
    // save SZC data
    const data = await http.put(`${API_BASE_CEAM}/api/szc/${id}`, szc);

    // save related institutes
    await http.put(`${API_BASE_CEAM}/api/szc/${szc.naturalId}/intezmenys`, {
      intezmenyNaturalIds: instituteIds,
    });

    // redirect
    if (data) props.history.push(ROUTES.edirSzcAll);
  };

  if (!szc) return <Spinner />;

  return (
    <SZCForm
      isEditing
      initialState={szc}
      submitBtnText="Módosít"
      title="EDIR SZC szerkesztése"
      handleSubmit={handleEditSubmit}
      imageRequired={false}
    />
  );
};

export default SZCEdit;
